<template>
  <div :class="['rounded-l-2large mx-2']">
    <div class="mt-8" v-if="isSwipeOpen">
      <!-- <h2
        :class="[
          'text-xl flex justify-begin justify-center mt-4',
        ]"
      >
        {{ lang["my_order"][language] }}
      </h2> -->
    </div>
    <!-- :style="hasKiosk&&menu.kiosk_checkout_height&&`height:${menu.kiosk_checkout_height}`" -->
    <div
    >
      <!-- :style="
        hasKiosk &&
        menu.kiosk_checkout_height &&
        `height:${menu.kiosk_checkout_height}`
      " -->
      <div
        class="w-full text-sm lg:text-base mb-10"
        cellspacing="0"
        v-if="!hasKiosk"
      >
        <transition-group name="list" tag="div">
          <div
            v-for="({ cartItem, amount }, index) in collectedCartItems"
            :key="cartItem.Id + `${index}`"
            :class="[
              'flex items-center mb-2 p-2 pb-4 h-full transition duration-500 border-b-2',
              backgroundColor ? theme.middleScreen.backgroundColor : '',
            ]"
          >
            <div class="w-4/5 flex">
              <div v-show="!backgroundColor" class="justify-center flex mr-4">
                <div class="w-12 h-12 overflow-hidden">
                  <Picture
                    v-if="cartItem.pictureUrl"
                    :src="cartItem.pictureUrl"
                    class="rounded-lg rouned-lg object-cover overflow-hidden"
                    alt
                  />
                </div>
              </div>
              <!-- left div -->
              <div class="text-left md:table-cell h-full w-3/4 pr-1">
                <p
                  :class="['text-sm lg:text-base font-medium']"
                  :style="processTekst"
                >
                  <small class="text-primary-light"></small>
                  {{ cartItem[`name_${language}`] }}
                </p>
                <div>
                  <small
                    :class="['text-xxs']"
                    v-for="(
                      additionGroup, index
                    ) in cartItem.OrderItemAdditions"
                    :key="index"
                    :style="processTekst"
                  >
                    {{ additionGroup["Addition"][`name_${language}`] }}
                    <!-- extra prices -->
                    <span
                      v-if="additionGroup['Addition']['price'] != 0"
                      v-currency="additionGroup['Addition']['price']"
                    >
                    </span>

                    <label v-if="index + 1 < cartItem.OrderItemAdditions.length"
                      >,</label
                    >
                  </small>
                </div>
              </div>
            </div>
            <div
              :class="['w-1/7 justify-begin flex ml-2']"
              :style="processTekst"
            >
              {{ amount }}
            </div>
            <div class="text-right md:table-cell w-1/4">
              <span
                v-if="hasKiosk"
                :class="[
                  'text-sm lg:text-base font-bold',
                  /* theme.body.textColor */ 'text-new-primary',
                ]"
                :style="text"
                v-currency="
                  filteredAdditionPrice && filteredAdditionPrice[index]
                    ? (cartItem.price + filteredAdditionPrice[index].price) * amount
                    : (cartItem.price * amount)
                "
              >
              </span>
              <span
                v-else
                :class="[
                  'text-sm lg:text-base font-bold',
                  /* theme.body.textColor */ 'text-new-primary',
                ]"
                :style="text"
                v-currency="
                  filteredAdditionPrice && filteredAdditionPrice[index]
                    ? (cartItem.price +
                      filteredAdditionPrice[
                        filteredAdditionPrice.length - index - 1
                      ].price) * amount
                    : (cartItem.price * amount)
                "
              >
              </span>
            </div>
            <div class="flex w-1/6 justify-end mr-1">
              <div>
                <div>
                  <a @click.prevent="removeItem(cartItem)">
                    <IconCancel
                      :backgroundColor="cartItemDestructiveButtonBackgroundColor"
                      :fill="cartItemDestructiveButtonColor"
                      :stroke="cartItemDestructiveButtonColor"
                    />
                  </a>
                </div>
              </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </transition-group>
      </div>
      <div class="mx-auto w-9/12" v-else>
        <div :class="['cartScrollbar',hasKiosk && menu.kiosk_checkout_height ? 'overflow-scroll' : 'scrollHeight']"
        :style="
        hasKiosk &&
        menu.kiosk_checkout_height &&
        `height:${menu.kiosk_checkout_height}`
      ">
          <KioskOrderOverview />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";

import { sortCartByAdditions } from "../utils";

import KioskOrderOverview from "../components/KioskOrderOverview";
import IconCancel from "../components/icons/iconCancel.vue";

export default {
  props: {
    backgroundColor: String,
  },
  components: {
    KioskOrderOverview,
    IconCancel,
  },
  data() {
    return {
      lang: lang,
      totalExtraPrices: 0,
      languageStorage: localStorage.getItem("language"),
      additionPrice: [],
      filteredAdditionPrice: null,
    };
  },
  computed: {
    ...mapGetters([
      "currency",
      "language",
      "menuHash",
      "theme",
      "menu",
      "isSwipeOpen",
      "hasKiosk",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "totalPriceValue",
      "tipAmount",
      "totalPriceValueWithCosts",
      "totalPriceValueWithCostsValue",
      "discountAmount",
      "discountInfo",
      "discountCode",
      "homeDelivery",
      "homeDeliveryCosts",
      "minSpent_w_charg_delivery",
    ]),
    ...mapState(["languageLocales"]),
    ...mapGetters("Theme", [
      "paymentFloatBackground",
      "addButtonRadius",
      "cartProcessItemRadius",
      "text",
      "borderMain",
      "processTekst",
      "btnDestructiveIcon",
      "totalPriceColor",
      "totalPriceText",
      "cartItemDestructiveButtonBackgroundColor",
      "cartItemDestructiveButtonColor"
    ]),
    // get all the cart items and sort them by additions
    collectedCartItems() {
      const items = this.cartItems;
      const result = sortCartByAdditions(items);
      return result;
    },
  },
  methods: {
    // shows the correct price per item in the cart (item price + addition prices)
    correctItemPrice() {
      if (this.cartItems) {
        let additionItemPrice = 0;
        let object = {};
        this.cartItems.map((x) => {
          let additionIds = []; 
          additionItemPrice = 0;
          if (x.OrderItemAdditions) {
            if (x.OrderItemAdditions.length == 0) {
              object = {
                id: x.Id,
                price: 0,
              };
              this.additionPrice.push(object);
            }
            x.OrderItemAdditions.map((y) => {
              additionItemPrice += y.Addition.price;
              additionIds.push(y.Addition.Id);
              object = {
                id: x.Id,
                price: additionItemPrice,
                additionIds: additionIds,
              };
            });
            this.additionPrice.push(object);
            this.filteredAdditionPrice = _.uniqWith(
              this.additionPrice,
              _.isEqual
            );
          } else {
            object = {
              id: x.Id,
              price: 0,
            };
            this.additionPrice.push(object);
          }
        });
      }
    },
    // removes the item and update the order
    removeItem(item) {
      this.additionPrice = [];
      this.filteredAdditionPrice = null;
      this.$store
        .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
        .then(() => {})
        .catch(() => {});
      this.correctItemPrice();
      this.$store.commit("updateIsSwipeOpen", false);
    },
    // checks discount code if it is valid or not
    addDiscountCode: _.debounce(function (event) {
      this.$store.commit("Cart/updateDiscountCode", event.target.value);
      this.$store.dispatch("Cart/VALIDATE_DISCOUNT_CODE", event.target.value);
    }, 1000),
    // check if you can continue to the next step or not
    updateClickable() {
      if (this.totalPriceValueWithCostsValue < this.menu.min_spent_amount) {
        this.$store.commit("updateIsCickable", "opacity-50 cursor-not-allowed");
      } else {
        this.$store.commit("updateIsCickable", " ");
      }
    },
  },
  mounted() {

    /** This is a temporaray solution to fix the header disappearing issue */
    // if (this.hasKiosk) {
    //   this.$nextTick(() => {
    //     let modelCart = document.getElementById('modalCart')
    //     modelCart.style.scrollMargin = '100px'
    //     modelCart.scrollIntoView()
    //   })    
    // }

    if (!this.menuHash) {
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    }
    // check if you can continue to the next step or not
    if (
      parseInt(this.totalPriceValue) + this.tipAmount <
        this.menu.min_spent_amount ||
      parseInt(this.totalPriceValue) + this.tipAmount <
        this.menu.min_spent_amount_delivery
    ) {
      this.$store.commit("updateIsCickable", "opacity-50 cursor-not-allowed");
    } else {
      this.$store.commit("updateIsCickable", " ");
    }
  },
  updated() {
    // check if you can continue ti the next step or not
    if (
      parseInt(this.totalPriceValue) + this.tipAmount <
        this.menu.min_spent_amount ||
      parseInt(this.totalPriceValue) + this.tipAmount <
        this.menu.min_spent_amount_delivery
    ) {
      this.$store.commit("updateIsCickable", "opacity-50 cursor-not-allowed");
    } else {
      this.$store.commit("updateIsCickable", " ");
    }
  },
  created() {
    this.correctItemPrice();
  },
};
</script>
<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}

.mobileScroll {
  height: 50vh;
  overflow: scroll;
  margin-bottom: 20px;
}

.scrollHeight {
  max-height: 60vh;
  overflow: auto;
}
</style>
